const DeviceWidthBreakpoint = {
  SMALL_MONITOR: 993,
};

export default DeviceWidthBreakpoint;
